var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileCheck = function SvgFileCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file_check_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file_check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.885 26.875a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V5.385q0-.947.656-1.604a2.18 2.18 0 0 1 1.604-.656h8.993q.45 0 .869.176.416.175.724.483l5.245 5.245q.308.308.483.724.176.418.176.87v13.992q0 .948-.656 1.604a2.18 2.18 0 0 1-1.604.656zm8.99-17.38q0 .483.323.807.324.323.807.323H22.5L16.875 5zm-3.207 9.603-1.99-1.99a1 1 0 0 0-.304-.209.9.9 0 0 0-.339-.07.98.98 0 0 0-.674.28.92.92 0 0 0-.291.668q0 .377.29.668L12.898 21a1.04 1.04 0 0 0 .79.32q.226 0 .421-.073.195-.072.37-.247l5.161-5.161a.94.94 0 0 0 .285-.672.92.92 0 0 0-.285-.684.93.93 0 0 0-.677-.29.93.93 0 0 0-.678.29z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileCheck);
export default ForwardRef;